// Theme choice (Settings): auto follows the system; light/dark pin it via <html data-theme> (daisyUI themes and
// the book.css tokens both key on it). Kept in localStorage; applied before first paint by index.html too.
import { create } from "zustand";
import { persist } from "zustand/middleware";

export const THEMES = ["auto", "light", "dark"] as const;
export type Theme = (typeof THEMES)[number];

export const applyTheme = (t: Theme) => {
	if (t === "auto") delete document.documentElement.dataset.theme;
	else document.documentElement.dataset.theme = t;
};

export const useTheme = create<{ theme: Theme; setTheme: (t: Theme) => void }>()(
	persist(
		(set) => ({
			theme: "auto",
			setTheme: (theme) => {
				applyTheme(theme);
				set({ theme });
			},
		}),
		{ name: "tasks.theme", onRehydrateStorage: () => (s) => applyTheme(s?.theme ?? "auto") },
	),
);
